import { render, staticRenderFns } from "./QuizFlavorImage.vue?vue&type=template&id=57167d8c&scoped=true&"
import script from "./QuizFlavorImage.vue?vue&type=script&lang=js&"
export * from "./QuizFlavorImage.vue?vue&type=script&lang=js&"
import style0 from "./QuizFlavorImage.vue?vue&type=style&index=0&id=57167d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57167d8c",
  null
  
)

export default component.exports